import Edit from './edit';

let routes = [];
routes = routes.concat({ path: 'edit', exact: true, name: 'basic', component: <Edit /> });

export default routes;
